import { render, staticRenderFns } from "./faqItem.vue?vue&type=template&id=87f888d6&scoped=true"
import script from "./faqItem.vue?vue&type=script&lang=js"
export * from "./faqItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f888d6",
  null
  
)

export default component.exports